import { useCallback, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { getStaffList } from "api/staff";
import BaseTable from "components/DataTable/BaseTable";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { formatDateTime, getRoleFilters, getStaffStatusFilters, STATUS_ACTIVE, STATUS_INACTIVE } from "utils/helper";

const TABLE_COLUMNS = [
    { id: "full_name", Header: "Full name", accessor: "fullname", align: "left", sortable: true },
    { id: "role", Header: "Role", accessor: "role", align: "left", sortable: true },
    { id: "start_working_date", Header: "Start Working Date", accessor: "workDate", align: "left" },
    { id: "created_at", Header: "Created At", accessor: "created_at", align: "left", sortable: true },
    { id: "status", Header: "Status", accessor: "status", align: "left" },
];

export const parentRoute = '/staffs';

const ROLE_FILTERS = getRoleFilters();
const STATUS_FILTERS = getStaffStatusFilters();

const STAFF_FILTER_CONFIGS = [
    { id: 'roles', label: 'Role', type: 'select', options: ROLE_FILTERS, placeholder: 'All Roles' },
    { id: 'status', label: 'Status', type: 'select', options: STATUS_FILTERS, placeholder: 'All Status' },
];

function StaffTable() {
    const navigate = useNavigate();
    const location = useLocation();
    const [refreshKey] = useState(0);
    const savedState = location.state || { sort: "created_at", dir: "desc" };

    const createTableRow = useCallback((item) => ({
        fullname: <MDTypography component="div" variant="standard" color="text">{item.full_name}</MDTypography>,
        role: <MDTypography component="div" variant="standard" color="text">{item.role?.name}</MDTypography>,
        workDate: <MDTypography component="div" variant="standard" color="text">{item.start_working_date || '-'}</MDTypography>,
        created_at: <MDTypography component="div" variant="standard" color="text">{formatDateTime(item.created_at)}</MDTypography>,
        status: <MDTypography component="div" variant="standard" color={item.status?.id === STATUS_ACTIVE ? "success" : item.status?.id === STATUS_INACTIVE ? "error" : "warning"}>{item.status?.name}</MDTypography>,
    }), []);

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <BaseTable
                key={refreshKey}
                queryKey={["staffs"]}
                title="Staffs Management"
                columns={TABLE_COLUMNS}
                fetchData={getStaffList}
                filterConfigs={STAFF_FILTER_CONFIGS}
                defaultState={savedState}
                createTableRow={createTableRow}
                showAddButton
                addButtonText="Add Staff"
                onAddClick={() => navigate(`${parentRoute}/add-staff`, { state: savedState })}
                showSearch
                searchPlaceholder="Search staff name..."
                onClickRow={(row, key) => { navigate(`${parentRoute}/${row.id}`, { state: savedState }) }}
            />
        </DashboardLayout>
    );
}

export default StaffTable;
